__turbopack_context__.v({
  "DM_12_24_Link_B": "Input-module-scss-module__J7DwHG__DM_12_24_Link_B",
  "DM_14_24_Link_B": "Input-module-scss-module__J7DwHG__DM_14_24_Link_B",
  "DM_20_24_Bold": "Input-module-scss-module__J7DwHG__DM_20_24_Bold",
  "DM_Body_Reg_16": "Input-module-scss-module__J7DwHG__DM_Body_Reg_16",
  "DM_Bold_14_16": "Input-module-scss-module__J7DwHG__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "Input-module-scss-module__J7DwHG__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "Input-module-scss-module__J7DwHG__DM_Bold_16_24",
  "DM_Bold_20_24": "Input-module-scss-module__J7DwHG__DM_Bold_20_24",
  "DM_Bold_40_56": "Input-module-scss-module__J7DwHG__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "Input-module-scss-module__J7DwHG__DM_Btn_16_16_Med",
  "DM_Med_10_12": "Input-module-scss-module__J7DwHG__DM_Med_10_12",
  "DM_Med_12_12_Chip": "Input-module-scss-module__J7DwHG__DM_Med_12_12_Chip",
  "DM_Med_12_16": "Input-module-scss-module__J7DwHG__DM_Med_12_16",
  "DM_Med_14_16": "Input-module-scss-module__J7DwHG__DM_Med_14_16",
  "DM_Med_14_20": "Input-module-scss-module__J7DwHG__DM_Med_14_20",
  "DM_Med_14_24": "Input-module-scss-module__J7DwHG__DM_Med_14_24",
  "DM_Med_16_16": "Input-module-scss-module__J7DwHG__DM_Med_16_16",
  "DM_Med_16_24": "Input-module-scss-module__J7DwHG__DM_Med_16_24",
  "DM_Med_18_24": "Input-module-scss-module__J7DwHG__DM_Med_18_24",
  "DM_Med_20_24": "Input-module-scss-module__J7DwHG__DM_Med_20_24",
  "DM_Med_24_24": "Input-module-scss-module__J7DwHG__DM_Med_24_24",
  "DM_Med_32_32": "Input-module-scss-module__J7DwHG__DM_Med_32_32",
  "DM_Med_32_48": "Input-module-scss-module__J7DwHG__DM_Med_32_48",
  "DM_Med_8_8": "Input-module-scss-module__J7DwHG__DM_Med_8_8",
  "DM_Reg_10_10": "Input-module-scss-module__J7DwHG__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "Input-module-scss-module__J7DwHG__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "Input-module-scss-module__J7DwHG__DM_Reg_12_16",
  "DM_Reg_14_16": "Input-module-scss-module__J7DwHG__DM_Reg_14_16",
  "DM_Reg_14_24": "Input-module-scss-module__J7DwHG__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "Input-module-scss-module__J7DwHG__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "Input-module-scss-module__J7DwHG__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "Input-module-scss-module__J7DwHG__DM_Reg_16_20",
  "DM_Reg_16_24": "Input-module-scss-module__J7DwHG__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "Input-module-scss-module__J7DwHG__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "Input-module-scss-module__J7DwHG__DM_Reg_18_28",
  "DM_Reg_32_32": "Input-module-scss-module__J7DwHG__DM_Reg_32_32",
  "DM_Reg_40_56": "Input-module-scss-module__J7DwHG__DM_Reg_40_56",
  "blue": "Input-module-scss-module__J7DwHG__blue",
  "characterCount": "Input-module-scss-module__J7DwHG__characterCount",
  "darkBlue": "Input-module-scss-module__J7DwHG__darkBlue",
  "description": "Input-module-scss-module__J7DwHG__description",
  "disabled": "Input-module-scss-module__J7DwHG__disabled",
  "downButton": "Input-module-scss-module__J7DwHG__downButton",
  "error": "Input-module-scss-module__J7DwHG__error",
  "errorText": "Input-module-scss-module__J7DwHG__errorText",
  "footer": "Input-module-scss-module__J7DwHG__footer",
  "gray": "Input-module-scss-module__J7DwHG__gray",
  "icon": "Input-module-scss-module__J7DwHG__icon",
  "input": "Input-module-scss-module__J7DwHG__input",
  "inputContainer": "Input-module-scss-module__J7DwHG__inputContainer",
  "inputWrapper": "Input-module-scss-module__J7DwHG__inputWrapper",
  "label": "Input-module-scss-module__J7DwHG__label",
  "leftIcon": "Input-module-scss-module__J7DwHG__leftIcon",
  "medium": "Input-module-scss-module__J7DwHG__medium",
  "numberButton": "Input-module-scss-module__J7DwHG__numberButton",
  "numberButtons": "Input-module-scss-module__J7DwHG__numberButtons",
  "rightIcon": "Input-module-scss-module__J7DwHG__rightIcon",
  "upButton": "Input-module-scss-module__J7DwHG__upButton",
  "withLeftIcon": "Input-module-scss-module__J7DwHG__withLeftIcon",
  "withNumberButtons": "Input-module-scss-module__J7DwHG__withNumberButtons",
  "withRightIcon": "Input-module-scss-module__J7DwHG__withRightIcon",
});
